import * as React from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import Text from './Text';
import { hitSlopS, rem } from './values';
const TextLink = ({ title, onPress }) => (<View style={styles.container}>
    <TouchableOpacity onPress={onPress} hitSlop={hitSlopS}>
      <Text Text-16 Primary>
        {title}
      </Text>
    </TouchableOpacity>
  </View>);
export default TextLink;
const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        paddingVertical: rem(8),
    },
});
